module.exports = __webpack_public_path__ + "img/pickThree.4607404d.png";